import React from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
interface TimePreferenceProps {
  selected: string;
  onSelect: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const TimePreference = ({
  selected,
  onSelect,
  onNext,
  onBack
}: TimePreferenceProps) => {
  const timeOptions = [{
    value: '5',
    label: '5 minutes'
  }, {
    value: '10',
    label: '10 minutes'
  }, {
    value: '15',
    label: '15+ minutes'
  }];
  return <div className="flex flex-col h-full p-6" data-id="element-807">
      <div className="mb-8" data-id="element-808">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-809">
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-810">
          How much time do you usually have for movement?
        </h1>
        <p className="text-gray-600" data-id="element-811">
          We'll tailor your workouts to fit your schedule.
        </p>
      </div>
      <div className="space-y-4 mb-8" data-id="element-812">
        {timeOptions.map(option => <Card key={option.value} onClick={() => onSelect(option.value)} active={selected === option.value} className="flex items-center p-5" data-id="element-813">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-814">
              <span className="text-blue-500 font-medium" data-id="element-815">{option.value}</span>
            </div>
            <span className="text-lg" data-id="element-816">{option.label}</span>
          </Card>)}
      </div>
      <div className="mt-auto" data-id="element-817">
        <Button onClick={onNext} variant="primary" fullWidth disabled={!selected} className={!selected ? 'opacity-50 cursor-not-allowed' : ''} data-id="element-818">
          Continue
        </Button>
      </div>
    </div>;
};